import React from "react";
import { OptimizedGantt } from "@planzone/dto";

function useHover() {
  const [hoveredElement, setHoveredElement] = React.useState<
    OptimizedGantt[number] | null
  >(null);

  const hoverElement = (element: OptimizedGantt[number]) =>
    (hoveredElement === null || hoveredElement.uuid !== element.uuid) &&
    setHoveredElement(element);

  const leaveElement = (element: OptimizedGantt[number]) =>
    hoveredElement !== null &&
    element.uuid === hoveredElement.uuid &&
    setHoveredElement(null);

  return {
    hoveredElement,
    hoverElement,
    leaveElement,
  };
}

export { useHover };
